import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { MenuButton, MenuLink, Option, SignOut } from './StyledComponents.jsx';

const RegisteredUserOptions = ({ onSwitchBoardsClick, userType }) => {
  const { t } = useTranslation('header');
  const { clientAdminView } = useSelector(state => state.currentUser || {});
  return (
    <Fragment>
      <Option>
        <MenuButton type="button" onClick={() => onSwitchBoardsClick()}>
          {t('account.switchBoards')}
        </MenuButton>
      </Option>

      <Option>
        <MenuLink href="/account/settings/edit">
          {t('account.settings')}
        </MenuLink>
      </Option>

      {userType === 'site admin' && (
        <>
          <Option>
            <MenuLink href="/admin">{t('account.siteAdmin')}</MenuLink>
          </Option>
          {!clientAdminView && (
            <Option>
              <MenuLink href="/toggle_admin_view" data-method="post">
                {t('account.clientAdminView')}
              </MenuLink>
            </Option>
          )}
          <Option>
            <MenuLink href="/client_admin/changelog">
              {t('account.changelog')}
            </MenuLink>
          </Option>
        </>
      )}

      <SignOut>
        <MenuLink
          id="signOut"
          rel="nofollow"
          data-method="delete"
          href="/sign_out"
        >
          {t('account.signOut')}
        </MenuLink>
      </SignOut>
    </Fragment>
  );
};

export default RegisteredUserOptions;
